import * as orderservice from './orders'

export default orderservice;